import * as React from 'react';
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  // MenuItem,
  Snackbar,
  SnackbarContent,
  TextField,
  Tooltip,
  Typography
} from '@material-ui/core';
import green from '@material-ui/core/colors/green';
import red from '@material-ui/core/colors/red';
import Rest from "../../../services/Rest";
import SupervisorAccount from '@material-ui/icons/SupervisorAccount';

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  dense: {
    marginTop: 19,
  },
  error: {
    backgroundColor: red[600],
  },
  form: {
    display: 'flex'
  },
  menu: {
    width: 200,
  },
  success: {
    backgroundColor: green[600],
  },
  textField: {
    marginLeft: 5,
    marginRight: 5,
  },
}

export interface IBookstoreUfFilterEntity {
  id: number;
  state: string;
}

// tslint:disable-next-line:no-empty-interface
export interface IAdminUsersProps {
}

export interface IAdminUsersState {
  alertMessage: string,
  alertOpened: boolean,
  alertType: string,
  cadastro: {
    email: string,
    password: string
  },
  dialogOpen: boolean,
  pesquisa: {
    email: string,
    idSso: string
  }
}

export class AdminUsers extends React.Component<IAdminUsersProps, IAdminUsersState> {
  constructor(props: IAdminUsersProps) {
    super(props);

    this.state = {
      alertMessage: '',
      alertOpened: false,
      alertType: 'success',
      cadastro: {
        email: '',
        password: ''
      },
      dialogOpen: false,
      pesquisa: {
        email: '',
        idSso: '',
      }
    }
  }

public closeAlert = (event: object, reason: string) => {
  if (reason === 'clickaway') {
    return;
  }

  this.setState({ alertOpened: false });
}

public render() {
  return  <div className="filter-item">
            <IconButton
              ia-owns={open ? 'simple-popper' : null}
              aria-haspopup="true"
              onClick={this.handleDialogOpen}
              color="inherit"
              aria-label="Menu Apps"
              className="menu-icon-bar">
              <SupervisorAccount />
            </IconButton>

            <Dialog
              open={this.state.dialogOpen}
              onClose={this.handleDialogClose}
              aria-labelledby="economic-group-dialog-title"
              aria-describedby="alereconomic-group-dialog-description"
              className="filter-dialog"
              disableBackdropClick={true}
              disableEscapeKeyDown={true}
            >
              <DialogTitle className="filter-dialog-title" id="economic-group-dialog-title">{"Manutenção de Usuários"}</DialogTitle>

              <DialogContent className="filter-dialog-content">
                <Grid container={true} direction="column" spacing={24}>
                  <Grid item={true}>
                    <Card>
                      <CardContent>
                        <Typography variant="title" component="h2">
                        Criação
                        </Typography>
                        <form style={styles.form}>
                          <TextField
                            id="outlined-email-input"
                            label="E-mail"
                            style={this.textFieldStyle(70)}
                            value={this.state.cadastro.email}
                            onChange={this.handleChangeCadastro('email')}
                            type="email"
                            name="email"
                            autoComplete="email"
                            margin="normal"
                            required={true}
                          />
                          <Tooltip disableHoverListener={true} title={
                            <React.Fragment>
                              <Typography color="inherit">Mínimo de 8 caracteres</Typography>
                              <Typography color="inherit">1 letra maiúscula</Typography>
                              <Typography color="inherit">1 letra minúscula</Typography>
                              <Typography color="inherit">1 número</Typography>
                              <Typography color="inherit">1 caracter especial</Typography>
                            </React.Fragment>
                          }
                          placement="bottom-end">
                            <TextField
                                id="standard-password-input"
                                label="Senha"
                                value={this.state.cadastro.password}
                                onChange={this.handleChangeCadastro('password')}
                                style={this.textFieldStyle(30)}
                                type="password"
                                autoComplete="current-password"
                                margin="normal"
                                required={true}
                              />
                          </Tooltip>
                        </form>
                      </CardContent>
                      <CardActions>
                        <Button className="filter-dialog-clear" onClick={this.handleClearCadastro} >
                          Limpar
                        </Button>
                        <Button className="filter-dialog-close" onClick={this.saveUser} color="primary">
                          Salvar
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                  
                  <Grid item={true}>
                    <Card>
                      <CardContent>
                        <Typography variant="title" component="h2">
                        Pesquisa
                        </Typography>
                        <form style={{'display': 'flex', 'flexWrap': 'wrap'}}>
                          <TextField
                            id="outlined-email-input"
                            label="E-mail"
                            style={styles.textField}
                            value={this.state.pesquisa.email}
                            onChange={this.handleChangePesquisa('email')}
                            type="email"
                            name="email"
                            autoComplete="email"
                            margin="normal"
                            required={true}
                            fullWidth={true}
                          />
                        <SnackbarContent style={ {'marginTop': 20, 'width': '-webkit-fill-available'} } message={this.state.pesquisa.idSso}/>
                        </form>
                      </CardContent>
                      <CardActions>
                        <Button className="filter-dialog-clear" onClick={this.handleClearPesquisa} >
                          Limpar
                        </Button>
                        <Button className="filter-dialog-close" onClick={this.searchUser} color="primary">
                          Pesquisar
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions className="filter-actions">
                <Snackbar
                  anchorOrigin={{
                    horizontal: 'center',
                    vertical: 'center',
                  }}
                  open={this.state.alertOpened}
                  autoHideDuration={4000}
                  onClose={this.closeAlert}>
                  <SnackbarContent message={this.state.alertMessage} style={this.alertStyle()}/>
                </Snackbar>
                <Button className="filter-dialog-close" onClick={this.handleDialogClose} >
                  Fechar
                </Button>
              </DialogActions>
            </Dialog>
          </div>
  }

  private alertStyle = () => {
    return styles[this.state.alertType];
  }

  private textFieldStyle = (size: number) => {
    return Object.assign({}, styles.textField, { flex: size })
  }

  private searchUser = () => {
    if (!this.state.pesquisa.email) {
      return;
    }
    Rest.GET('sso', this.state.pesquisa.email)
      .then(response => response.json())
      .then(resultado => {
        this.fillIdSso(resultado.id)
      })
  }

  private validDataForSave = () => {
    return this.state.cadastro.email && this.state.cadastro.password;
  }

  private saveUser = () => {
    if (!this.validDataForSave()) {
      return this.errorSaveUser('É obrigatório informar o E-mail e a Senha para cadastro.');
    }
    Rest.POST('sso', this.state.cadastro)
    .then(({ data }):string => data)
    .then(id => {
      this.userSuccessSaved(id)
    })
    .catch(err => {
      this.errorSaveUser('')
    })
  }

  private userSuccessSaved(id: string) {
    const pesquisa = { email: this.state.cadastro.email, idSso: id }
    this.setState({ pesquisa })
    this.openAlert(true, 'success', 'Cadastro realizado com sucesso.');
    this.handleClearCadastro()
  }

  private errorSaveUser(msg: string) {
    this.openAlert(true, 'error', msg || 'Erro. Verifique se o email já existe e se a senha segue as regras para cadastro.');
  }

  private openAlert(alertOpened: boolean, alertType: string, alertMessage: string) {
    this.setState({ alertType })
    this.setState({ alertMessage })
    this.setState({ alertOpened })
  }

  private handleChangeCadastro = (param: any) => (event: React.FormEvent<HTMLInputElement>) => {
    const cadastro = Object.assign({}, this.state.cadastro);
    cadastro[param] = event.currentTarget.value;
    this.setState({ cadastro });
  };

  private handleChangePesquisa = (param: any) => (event: React.FormEvent<HTMLInputElement>) => {
    const pesquisa = Object.assign({}, this.state.pesquisa);
    pesquisa[param] = event.currentTarget.value;
    this.setState({ pesquisa });
  };

  private handleDialogOpen = () => {
    // tslint:disable-next-line:no-string-literal
    this.setState({ dialogOpen: true });
  };

  private handleDialogClose = () => {
    this.handleDialogClear();
    this.setState({ dialogOpen: false });
  };

  private handleDialogClear = () => {
    this.handleClearCadastro();
    this.handleClearPesquisa();
  }

  private handleClearCadastro = () => {
    this.setState({
      cadastro: {
      email: '',
      password: ''
    }});
  }

  private handleClearPesquisa = () => {
    this.setState({
      pesquisa: {
        email: '',
        idSso: '',
      }
    });
  }

  private fillIdSso = (idSso: string) => {
    const pesquisa = Object.assign({}, this.state.pesquisa)
    pesquisa.idSso = idSso
    this.setState({ pesquisa });
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/admin/AdminUsers.tsx